import React from 'react';
import { Box, Stack } from '@mui/material';
import { DescriptionOutlined } from '@mui/icons-material';
import { SectionHeaderWithCommand, SectionPaper } from '../../../../common/components';
import {
  TemplateTitleEdit,
  CategoryEdit,
  PriorityEdit
} from '../fields/templateInformation';

interface TemplateInformationSectionProps {
  isEditMode?: boolean;
}

/**
 * TemplateInformationSection - Contains template basic information
 */
export const TemplateInformationSection: React.FC<TemplateInformationSectionProps> = ({ isEditMode = false }) => {
  return (
    <Box>
      <SectionHeaderWithCommand
        icon={<DescriptionOutlined sx={{ mr: 1, color: '#3b82f6', fontSize: 18 }} />}
        title="Template Information"
      />
      
      <SectionPaper>
        <Stack spacing={2}>
          <TemplateTitleEdit />
          <Stack direction="row" gap={2}>
            <CategoryEdit isEditMode={isEditMode} />
            <PriorityEdit />
          </Stack>
        </Stack>
      </SectionPaper>
    </Box>
  );
};

export default TemplateInformationSection;
